<script>
import { REAL_ESTATE_ICON_PATHS } from './icons';

export default {
  name: 'RealEstateIcon',
  props: {
    icon: {
      type: String,
      required: true,
      validator: value => Object.keys(REAL_ESTATE_ICON_PATHS).includes(value),
    },
    size: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    path() {
      return REAL_ESTATE_ICON_PATHS[this.icon];
    },
  },
};
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path :d="path" />
  </svg>
</template>
